import React from 'react';
import styled from 'styled-components';
import { UiText, UiFlex } from '@open-stack/ui';
import { MenuProduct } from '../../../XV2';
import { useCurrency } from '../../../hooks/currency';
import { useActiveZoneMenuProduct } from '../../../hooks/useActiveZoneMenuProduct';

const Wrapper = styled(UiFlex)`
    .old {
        text-decoration: line-through;
        color: var(--x-color-text-secondary);
        font-size: 1rem;
    }

    .new {
        background-color: var(--x-color-success);
        color: white;
        font-weight: bold;
        border-radius: var(--border-radius-large);
        padding: 2px var(--ui-spacing);
        font-size: 1rem;
    }
`;

interface Props {
    menuProduct: MenuProduct;
}

export function MenuProductPriceLabel({ menuProduct }: Props) {
    const activeZoneMenuProduct = useActiveZoneMenuProduct(menuProduct);
    const { format } = useCurrency();

    if (activeZoneMenuProduct.isFree) {
        return null;
    }

    const elementPrice = <UiText className="price">{format(activeZoneMenuProduct.getListItemPrice())}</UiText>;

    if (activeZoneMenuProduct.isDiscounted) {
        return (
            <>
                <Wrapper gap={1}>
                    <span className="old">{format(activeZoneMenuProduct.priceWithoutDiscount)}</span>
                    <span className="new">{elementPrice}</span>
                </Wrapper>
            </>
        );
    }

    return elementPrice;
}
